import { Decoder } from "./decoder";
import { Encoder } from "./encoder";
import { Encoding } from "./encoding";

type BOMValue = Uint8Array | null;

class BOM {
  private _value: BOMValue;

  private _length: number;

  private _enconding: Encoding;

  constructor(value: BOMValue, encoding: Encoding) {
    this._enconding = encoding;
    this._value = value;
    this._length = value?.length || 0;
  }

  get value() {
    return this._value;
  }

  get encoding() {
    return this._enconding;
  }

  get length() {
    return this._length;
  }

  newEncoder() {
    return new Encoder(this._enconding, this._value);
  }

  newDecoder() {
    return new Decoder(this._enconding, this._value);
  }
}

const bomUTF8 = new Uint8Array([0xef, 0xbb, 0xbf]);
const bomUTF16LE = new Uint8Array([0xff, 0xfe]);
const bomUTF16BE = new Uint8Array([0xfe, 0xff]);
const bomUTF32LE = new Uint8Array([0xff, 0xfe, 0x00, 0x00]);
const bomUTF32BE = new Uint8Array([0x00, 0x00, 0xfe, 0xff]);

const boms = [bomUTF32LE, bomUTF32BE, bomUTF16LE, bomUTF16BE, bomUTF8];

export function detectBOM(data: Uint8Array): BOM | null {
  for (const bom of boms) {
    if (hasPrefix(data, bom)) {
      return new BOM(bom, getEncoding(bom));
    }
  }
  return null;
}

function hasPrefix(data: Uint8Array, prefix: Uint8Array): boolean {
  if (data.length < prefix.length) {
    return false;
  }
  for (let i = 0; i < prefix.length; i += 1) {
    if (data[i] !== prefix[i]) {
      return false;
    }
  }
  return true;
}

function getEncoding(bom: Uint8Array | null): Encoding {
  if (bom === null) {
    return Encoding.UTF8;
  }
  if (equalArrays(bom, bomUTF8)) {
    return Encoding.UTF8;
  }
  if (equalArrays(bom, bomUTF16LE)) {
    return Encoding.UTF16LE;
  }
  if (equalArrays(bom, bomUTF16BE)) {
    return Encoding.UTF16BE;
  }
  if (equalArrays(bom, bomUTF32LE)) {
    throw new Error("Browsers do not support UTF32LE");
  }
  if (equalArrays(bom, bomUTF32BE)) {
    throw new Error("Browsers do not support UTF32BE");
  }
  return Encoding.UTF8;
}

function equalArrays(a: Uint8Array, b: Uint8Array): boolean {
  if (a.length !== b.length) {
    return false;
  }
  for (let i = 0; i < a.length; i += 1) {
    if (a[i] !== b[i]) {
      return false;
    }
  }
  return true;
}
